<template>
  <div class="chat-view">
    <div class="loader" v-if="loading">
      <div class="spinner"></div>
    </div>

    <div class="chat-area">
      <div ref="messagesContainer" class="messages">
        <template v-if="messages.length === 0 && !loading">
          <div class="no-messages">
            Упс, чат уже неактивен или удален! Попросите новую ссылку на чат у автора. Срок действия ссылки 5 дней.
          </div>
        </template>
        <template v-else>
          <message v-for="msg in messages" :message="msg" :key="msg.id" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { yandexApi } from './api/yandex-api';
import message from './message.vue';
import Vue from 'vue';

export default {
  props: {
    sharedThreadId: {
      type: String,
    }
  },
  data() {
    return {
      threads: [],
      currentThread: null,
      messages: [],
      newMessage: '',
      loading: false,
      menuVisible: false
    };
  },
  components: {
    message,
  },
  methods: {
    async fetchMessages() {
      try {
        this.loading = true;
        const { data } = await yandexApi.get(`/messages`, { params: { threadId: this.sharedThreadId } });
        this.messages = (data || []).map((m, i) => ({ ...m, id: m.id || `local-${i}` })).reverse();
        this.loading = false;
      } catch (error) {
        console.error('Error fetching messages:', error);
        this.loading = false;
      }
    }
  },
  mounted() {
    this.currentThread = { id: -1 };
    this.fetchMessages();
  },
};
</script>

<style scoped>
.loader {
  position: absolute;
  top: 40%;
  right: 50%;
  z-index: 10;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 4.5px solid rgba(250, 241, 241, 0.4);
  border-left-color: #e74c3c;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.chat-view {
  display: flex;
  height: 100%;
  overflow: hidden;
}

/* Основная чат-зона */
.chat-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative; /* Добавлено для корректного absolute позиционирования input-area */
  min-height: 0;
}

.messages {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.no-messages {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #888;
  font-size: 14px;
  user-select: none;
  text-align: center;
}

/* === Адаптивные стили для мобильных и планшетов === */

@media (max-width: 768px) {
  .chat-area {
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared-chat.vue